var Field = require('../field'),
	renderAttrs = Field.renderAttrs;

// The init function is called on both the server and browser
// before rendering
exports.init = function(model) {
	model.set('row-class', 'text ' + (model.get('row-class') || ''));

    var args = Field.init(model);
    //model.set('inputTag', '<input type="email"' + renderAttrs(args) + '>');

    model.set('inputTag', '<input>');
}